// Minimal A/B variant helper for the homepage experiment.
// Variant A = "/" (LandingPage, control), Variant B = "/b" (LandingPageB, treatment).
// Routes decide which variant renders; this only records/reports which one a visitor saw
// so it can be pushed to GTM/GA4 as a dimension on every event fired from that page.

const STORAGE_KEY = 'vt-ab-variant'

export function getStoredVariant() {
  try {
    return localStorage.getItem(STORAGE_KEY)
  } catch (error) {
    return null
  }
}

export function setStoredVariant(variant) {
  try {
    localStorage.setItem(STORAGE_KEY, variant)
  } catch (error) {
    // ignore storage failures (private browsing, etc.)
  }
}
